import { DELAY_UNTIL_SKELETONS_DISAPPEAR } from 'www/vue_components/common/AppointmentPage/constants'

const AppointmentPageMethods = {
  data: () => ({
    loadingTimeoutId: null,
    isLoading: true,
  }),
  methods: {
    callOrOnceWatch(getTrackingValue, callback) {
      if (getTrackingValue()) {
        callback()
      } else {
        const unwatch = this.$watch(getTrackingValue, value => {
          if (value) {
            callback()
            unwatch()
          }
        })
      }
    },
    timeoutLoading(isLoading, mutableObject = this) {
      clearTimeout(mutableObject.loadingTimeoutId)

      if (isLoading) {
        mutableObject.isLoading = isLoading
        return
      }

      mutableObject.loadingTimeoutId = setTimeout(() => {
        mutableObject.isLoading = isLoading
      }, DELAY_UNTIL_SKELETONS_DISAPPEAR)
    },
  },
}

export default AppointmentPageMethods
